// Bundle NACA — ajoute automatiquement le liner assorti à la taille de casque choisie.
// Dédié au bundle casque NACA : ne touche à aucun élément partagé du thème.
(function () {
  function initNacaBundle() {
    var root = document.querySelector('.bundle-casque-naca');
    var btn = root ? root.querySelector('.naca-bundle-atc-btn') : null;
    if (!btn || btn.dataset.nacaInit) return;
    btn.dataset.nacaInit = 'true';

    var errorEl = root.querySelector('.naca-bundle-error');
    var qtyInput = root.querySelector('quantity-selector input');

    var mappingEl = root.querySelector('.naca-bundle-mapping');
    var mapping = {};
    try {
      if (mappingEl) mapping = JSON.parse(mappingEl.textContent);
    } catch (e) {
      mapping = {};
    }

    function showError(message) {
      errorEl.querySelector('p').innerHTML = message + ' Please contact us at <a href="https://paddtack.com/pages/contact">hello@paddtack.com</a>.';
      errorEl.style.display = 'block';
    }

    function getSelectedCasqueVariantId() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      var input = form.querySelector('[name="id"]');
      return input ? input.value : null;
    }

    btn.addEventListener('click', async function () {
      errorEl.style.display = 'none';

      var casqueId = getSelectedCasqueVariantId();
      var qty = parseInt(qtyInput.value) || 1;

      if (!casqueId) {
        showError('Please select a helmet size before adding to cart.');
        return;
      }

      var linerId = mapping[casqueId];
      if (!linerId) {
        showError('Unfortunately, the liner for this size is no longer available.');
        return;
      }

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: parseInt(casqueId), quantity: qty, properties: { '_bundle_type': 'naca' } },
              { id: parseInt(linerId), quantity: qty, properties: { '_bundle': 'true', '_bundle_liner': 'true', '_bundle_type': 'naca' } }
            ]
          })
        });
        if (!response.ok) throw new Error('Cart error');

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          var trigger = document.querySelector('[data-drawer-open="cart-drawer"], [aria-controls="cart-drawer"]');
          if (trigger) trigger.click();
        }
      } catch (e) {
        showError('Something went wrong adding the bundle to your cart.');
      } finally {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initNacaBundle);
  // Chaque changement de taille déclenche un re-rendu partiel natif du bloc produit
  // (<product-rerender allow-partial-rerender> dans main-product.liquid) : notre bloc, étant un
  // bloc "liquid", est entièrement remplacé par une copie fraîche venue du serveur à chaque
  // sélection — bouton neuf, sans le listener ci-dessus. "variant:change" (sur le formulaire,
  // bulles) se déclenche juste après ce remplacement, donc on réattache le script dessus.
  document.addEventListener('variant:change', initNacaBundle);
})();
